<span #anchor class="focus-anchor" tabindex="-1"></span>
<ng-content></ng-content>
